import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "schedule-loading"
};
const _hoisted_2 = {
  key: 1,
  class: "schedule-list"
};
const _hoisted_3 = {
  class: "event-row d-none d-md-flex"
};
const _hoisted_4 = {
  class: "event-left"
};
const _hoisted_5 = {
  class: "event-title-row"
};
const _hoisted_6 = {
  key: 0,
  class: "live-badge"
};
const _hoisted_7 = {
  class: "event-title"
};
const _hoisted_8 = {
  class: "event-meta"
};
const _hoisted_9 = ["href"];
const _hoisted_10 = {
  class: "event-right"
};
const _hoisted_11 = ["href"];
const _hoisted_12 = {
  class: "event-mobile d-md-none"
};
const _hoisted_13 = {
  class: "event-mobile-top"
};
const _hoisted_14 = {
  key: 0,
  class: "live-badge"
};
const _hoisted_15 = {
  class: "event-title mobile-title"
};
const _hoisted_16 = {
  class: "event-meta"
};
const _hoisted_17 = ["href"];
const _hoisted_18 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_router_link = _resolveComponent("router-link");
  const _component_b_container = _resolveComponent("b-container");
  return _openBlock(), _createBlock(_component_b_container, {
    fluid: "",
    class: "schedule-list-wrap"
  }, {
    default: _withCtx(() => [_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_spinner), _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "schedule-loading-copy"
    }, [_createElementVNode("strong", null, "Loading Livestreams"), _createElementVNode("span", null, "Please wait while we fetch upcoming livestreams.")], -1))])) : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.streams, stream => {
      return _openBlock(), _createElementBlock("div", {
        key: stream.id,
        class: "event-card"
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [+stream.islive === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [_createElementVNode("span", {
        class: "live-dot"
      }, null, -1), _createTextVNode(" Live ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, _toDisplayString(stream.name), 1)]), _createElementVNode("div", _hoisted_8, [_cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "event-meta-icon"
      }, "🗓", -1)), _createElementVNode("span", null, _toDisplayString(stream.streamdatefull) + " — " + _toDisplayString(stream.streamtimefull), 1)]), _withDirectives(_createElementVNode("a", {
        href: stream.lineuplink,
        class: "event-program-link",
        target: "_blank"
      }, " Event Program ", 8, _hoisted_9), [[_vShow, stream.lineuplink && stream.lineuplink !== '']])]), _createElementVNode("div", _hoisted_10, [+stream.islive === 1 ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: stream.livehref,
        class: "watch-btn"
      }, " Watch Now ", 8, _hoisted_11)) : _createCommentVNode("", true), !$props.hideChannelLink ? (_openBlock(), _createBlock(_component_router_link, {
        key: 1,
        class: "channel-pill",
        to: {
          path: '/video/channel/' + stream.networkchannel_id,
          query: {
            tab: 'live'
          }
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(stream && stream.networkchannel && stream.networkchannel.name ? stream.networkchannel.name : 'Channel'), 1)], undefined, true),
        _: 2
      }, 1032, ["to"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [+stream.islive === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[3] || (_cache[3] = [_createElementVNode("span", {
        class: "live-dot"
      }, null, -1), _createTextVNode(" Live ", -1)]))])) : _createCommentVNode("", true), !$props.hideChannelLink ? (_openBlock(), _createBlock(_component_router_link, {
        key: 1,
        class: "channel-pill",
        to: {
          path: '/video/channel/' + stream.networkchannel_id,
          query: {
            tab: 'live'
          }
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(stream && stream.networkchannel && stream.networkchannel.name ? stream.networkchannel.name : 'Channel'), 1)], undefined, true),
        _: 2
      }, 1032, ["to"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, _toDisplayString(stream.name), 1), _createElementVNode("div", _hoisted_16, [_cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "event-meta-icon"
      }, "🗓", -1)), _createElementVNode("span", null, _toDisplayString(stream.streamdatefull) + " — " + _toDisplayString(stream.streamtimefull), 1)]), _withDirectives(_createElementVNode("a", {
        href: stream.lineuplink,
        class: "event-program-link",
        target: "_blank"
      }, " Event Program ", 8, _hoisted_17), [[_vShow, stream.lineuplink && stream.lineuplink !== '']]), +stream.islive === 1 ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: stream.livehref,
        class: "watch-btn mobile-watch-btn"
      }, " Watch Now ", 8, _hoisted_18)) : _createCommentVNode("", true)])]);
    }), 128))], 512)), [[_vShow, !_ctx.collapsed || !$props.collapseable]])], undefined, true),
    _: 1
  });
}